export default "__VITE_ASSET__CFflPHpM__"